import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { demoOutput, leadResponsePrompt } from '../../data/samplePrompts';
import { PromptCard } from './PromptCard';
export function PromptDemo() {
  return <div data-id="element-249" data-mp="3gn7iks2mr7nb">
      <div className="text-center" data-id="element-250" data-mp="3glwaig25jdqe">
        <h2 className="font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-251" data-mp="3gkuzgbl4yr8o">See it in action</h2>
        <p className="mt-3 text-base text-muted" data-id="element-252" data-mp="3blrtmoxc0gzn">Example: Instant Lead Response</p>
      </div>

      <div className="mt-10 grid items-start gap-8 lg:grid-cols-2" data-id="element-253" data-mp="2nw5xybg64jwe">
        <div data-id="element-254" data-mp="2j0i77rm1fios">
          <p className="mb-3 text-xs font-bold uppercase tracking-wider text-gold-ink" data-id="element-255" data-mp="2j0qjbhac6jyx">1 · You type this</p>
          <PromptCard n={leadResponsePrompt.n} title={leadResponsePrompt.title} text={leadResponsePrompt.text} data-id="element-256" data-mp="2xpegtt3qt3ri" />
        </div>

        <div data-id="element-257" data-mp="257sktm2lkbr5">
          <p className="mb-3 text-xs font-bold uppercase tracking-wider text-cyan-ink" data-id="element-258" data-mp="25791q217nhbj">2 · You get a structured starting point</p>
          <div className="rounded-2xl border border-line bg-canvas p-6" data-id="element-259" data-mp="207wfnji5yea0">
            <p className="flex items-center gap-2 border-b border-line pb-3 font-display text-sm font-black uppercase tracking-wide text-ink" data-id="element-260" data-mp="1scdp4n89s75y">
              <SparklesIcon className="h-4 w-4 text-cyan-ink" aria-hidden="true" data-id="element-261" data-mp="1wbmme22iqn69" />
              {demoOutput.title}
            </p>
            <ol className="mt-4 space-y-5" data-id="element-262" data-mp="263932dxmlege">
              {demoOutput.sections.map(s => <li key={s.heading} data-id="element-263" data-mp="2653ijcq4oed3">
                  <p className="font-display text-sm font-extrabold text-ink" data-id="element-264" data-mp="19drn964xic0z">{s.heading}</p>
                  {s.intro && <p className="mt-1 text-sm text-muted" data-id="element-265" data-mp="1dfmokamv0per">{s.intro}</p>}
                  {s.lines.length > 1 ? <ul className="mt-2 flex flex-wrap gap-2" data-id="element-266" data-mp="1ic3dh71vv7sw">
                      {s.lines.map(l => <li key={l} className="rounded-full border border-line bg-white px-3 py-1 text-xs font-medium text-ink" data-id="element-267" data-mp="1nec6g3era9v0">
                          {l}
                        </li>)}
                    </ul> : <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-268" data-mp="292zjgix8flyc">{s.lines[0]}</p>}
                </li>)}
            </ol>
          </div>
          <p className="mt-5 text-base font-semibold text-ink" data-id="element-269" data-mp="2j1ylhinhsjcd">You copy, customize and review.</p>
          <p className="text-sm text-muted" data-id="element-270" data-mp="2e2vmaeu717cb">No advanced prompt-engineering skills required.</p>
        </div>
      </div>
    </div>;
}